import script from "./FileUploadSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUploadSection.vue?vue&type=script&setup=true&lang=js"

import "./FileUploadSection.vue?vue&type=style&index=0&id=93eb0166&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93eb0166"]])

export default __exports__